/**
 * Otevře Codable chat a pošle požadavek agentovi (vysvětlit změny, sloučit větev).
 * Chat pane se při zavření odmontuje, proto se text drží, dokud se pane nechytí.
 */
export const CODABLE_CHAT_OPEN = 'codable:chat-open';
export const CODABLE_CHAT_ASK = 'codable:chat-ask';

let pending: { slug: string; text: string } | null = null;

export function askCodableChat(opts: { slug: string; text: string }): void {
  const slug = opts.slug.trim();
  const text = opts.text.trim();
  if (!slug || !text) return;
  pending = { slug, text };
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(CODABLE_CHAT_OPEN, { detail: { slug } }));
  window.dispatchEvent(new CustomEvent(CODABLE_CHAT_ASK, { detail: { slug, text } }));
}

export function takeCodableChatAsk(slug: string): string | null {
  if (!pending || pending.slug !== slug) return null;
  const text = pending.text;
  pending = null;
  return text;
}
